export default ".edtf-datapicker{\n  width:100%;\n}\n";